import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { LoginRequestDTO } from './DTO/request/LoginRequest.DTO';
import { Observable } from 'rxjs';
import { IToken } from './DTO/response/LoginResponse.DTO';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private urlApiHost = environment.api.host;
  private methods = environment.api.endpoints.methods;

  constructor(private http: HttpClient) { }

  public createTokenApi(form: LoginRequestDTO): Observable<IToken> {
    const url = this.urlApiHost + this.methods.autenticacao.autentication

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<IToken>(url, form, options);
  }

  public tokenApiVerify(token: string) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post<any>(
      `${ this.urlApiHost + this.methods.autenticacao.verify }`, token, options);
  }
}
